import React from 'react';
import { useSiteContent } from '../../lib/siteContent';

const METRICS = [
  { value: '₹42.8L+', label: 'Collections tracked' },
  { value: '10', label: 'Integrated modules' },
  { value: '∞', label: 'Branch ledgers' },
  { value: '< 60s', label: 'Workspace setup' },
  { value: '100%', label: 'Tenant isolated' },
  { value: '24/7', label: 'Mobile-first access' },
];

export default function LaunchMetricsStrip() {
  const { content } = useSiteContent();
  const hs = content.heroStats;
  const dynamic = [{ value: hs.collectionsValue || '₹42.8L', label: 'Live collections' }, ...METRICS.slice(1)];
  const items = [...dynamic, ...dynamic];

  return (
    <section className="relative z-10 border-y border-white/[0.06] py-5" aria-label="Platform metrics">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-emerald-600/5 via-transparent to-cyan-600/5" />
      <div className="overflow-hidden">
        <div className="animate-scroll gap-12 px-4">
          {items.map((m, i) => (
            <div key={`${m.label}-${i}`} className="flex shrink-0 items-center gap-4 px-6">
              <span className="font-display text-2xl font-bold text-white sm:text-3xl">{m.value}</span>
              <span className="text-sm font-medium uppercase tracking-wider text-slate-500">{m.label}</span>
              <span className="h-1 w-1 rounded-full bg-emerald-500/50" aria-hidden />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
